import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import ReactHtmlParser from 'react-html-parser';
import classnames from 'classnames';
import moment from 'moment';
import 'moment/locale/fr';
import AddIcon from '@material-ui/icons/Add';
import {getFirstLastDateSession} from '../../helpers';
import {truncateText} from '../../../../app/utils/text';
import {withLocalize} from 'react-localize-redux';
import PlaceholderImage from "../../../Schools/assets/img/placeholder-school-thumbnail.jpg";


class EventsListItem extends Component {
    render() {
        const {event} = this.props;

        moment.locale('fr');

        const uri = this.props.translate('routes.events_details').replace(':slug', event.slug);

        let thumbnailStyles = {};

        if (event.featured_image && event.featured_image.listing && event.featured_image.listing !== '') {
            thumbnailStyles = {
                backgroundImage: 'url("' + event.featured_image.listing + '")',
            };
        } else {
            thumbnailStyles = {
                backgroundImage: `url(${PlaceholderImage})`,
            };
        }

        let typeName = '';

        if (Array.isArray(event.types) && event.types.length > 0) {
            // Copy the array (not a reference) => mandatory because we call shift() and that the render() function may be called more than once...
            let copyTypes = event.types.slice(0);
            let type = copyTypes.shift();
            typeName = type.name;
        }

        let placeName = '';
        let placeAddress = '';

        if (Array.isArray(event.places) && event.places.length > 0) {
            // Copy the array (not a reference) => mandatory because we call shift() and that the render() function may be called more than once...
            let copyPlaces = event.places.slice(0);
            let place = copyPlaces.shift();
            placeName = place.name;

            if (place.address_city !== '') {
                if (place.address_postal_code !== '') {
                    placeAddress += place.address_postal_code + ' ';
                }
                placeAddress += place.address_city;
            }
        }

        const dateFormat = 'D MMM YY';
        let datesStr = '';
        let dates = getFirstLastDateSession(event.dates);

        if (dates.length === 1) {
            datesStr = moment(dates[0].date, 'YYYY-MM-DD').format(dateFormat);
        } else if (dates.length === 2) {
            if (dates[0].date && dates[1].date) {
                let dateTime1 = dates[0].date;
                let dateTime2 = dates[1].date;

                datesStr = moment(dateTime1, 'YYYY-MM-DD').format(dateFormat);
                datesStr += '<br />';
                datesStr += moment(dateTime2, 'YYYY-MM-DD').format(dateFormat);
            }
        }

        return (
            <div className="col-lg-3 col-md-6 col-sm-12" key={event.id}>
                <Link to={uri} className="item">
                    <div className='bg-image' style={thumbnailStyles}></div>
                    <div className="inner">
                        <div className="top">
                            {typeName !== '' &&
                                <div className="category">
                                    {typeName}
                                </div>
                            }
                            <div className={classnames('dates', {
                                'multiple': (dates.length > 1),
                            })}>
                                {ReactHtmlParser(datesStr)}
                            </div>
                        </div>
                        <div className="title">
                            {ReactHtmlParser(truncateText(event.title, 70))}
                        </div>
                        <div className="bottom">
                            {placeName !== '' &&
                                <Fragment>
                                    <div className="line-1">
                                        {ReactHtmlParser(placeName)}
                                    </div>
                                    {placeAddress !== '' &&
                                        <div className="line-2">{ReactHtmlParser(placeAddress)}</div>
                                    }
                                </Fragment>
                            }
                        </div>
                        <span className="btn-more"><AddIcon className="m-icon" /></span>
                    </div>
                </Link>
            </div>
        );
    }
}

EventsListItem.propTypes = {
    event: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(EventsListItem);


// WEBPACK FOOTER //
// ./src/features/Events/components/List/EventsListItem.js